var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 36,
    viewBox: "0 0 124 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27176_57487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3853 6.11531L30.9095 14.2045C30.7283 14.5273 29.9129 15.8463 29.632 16.0584C28.889 16.9531 27.8652 17.5434 26.7236 17.7464C26.4518 17.8386 25.3827 17.8939 25.0837 17.8939H10.1886L0.285645 35.8063H15.1717C16.0325 35.7971 19.1673 35.6218 19.9465 35.3082C23.0361 34.6718 25.7723 32.578 27.3669 29.691L31.8427 21.6019C32.0239 21.279 32.8393 19.96 33.1202 19.7479C33.8632 18.8532 34.896 18.2629 36.0376 18.0507C36.3094 17.9585 37.3695 17.9031 37.6685 17.9031H52.5636L62.4665 0H47.5895C46.7288 0.00922369 43.5939 0.184473 42.8147 0.498079C39.7161 1.12529 36.9799 3.22828 35.3853 6.11531Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3308 32.4986L35.4214 32.4525C37.5234 33.2642 39.7522 33.6239 42.8327 33.6239C46.1307 33.6239 47.535 33.0889 47.535 32.3049C47.535 30.0082 35.2583 33.0336 35.2583 27.61C35.2583 25.2672 37.7952 24.0312 42.6515 24.0312C45.0797 24.0312 47.3085 24.3357 49.3652 24.9536V27.361L49.2746 27.3887C47.1273 26.743 44.9257 26.4017 42.7149 26.4017C39.5529 26.4017 38.212 26.7984 38.212 27.5086C38.212 29.8053 50.4796 26.8721 50.4796 32.2219C50.4796 34.8414 48.1874 35.9944 42.6425 35.9944C39.8066 35.9944 37.2244 35.6439 35.3036 35.0259V32.4986H35.3308Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4813 24.3672V35.8138H52.5186V24.3672H55.4813Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3102 30.0437C60.3102 32.2758 62.3213 33.6225 66.2444 33.6225C67.4313 33.6225 68.5821 33.4288 69.6876 33.0967V31.0214H62.9741V29.0568H72.6414V34.4434C70.4303 35.5964 68.4645 35.993 66.1268 35.993C60.6002 35.993 57.3474 33.7885 57.3474 30.016C57.3474 26.2435 60.5911 24.0391 65.9635 24.0391C68.5188 24.0391 70.6389 24.528 72.6595 25.5886V28.1528L72.5685 28.1713C70.6027 27.0737 68.4916 26.4096 66.2444 26.4096C62.367 26.428 60.3102 27.7747 60.3102 30.0437Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8976 24.3672V35.8138H87.473L78.1137 27.6785V35.8138H75.1509V24.3672H78.268L87.9353 32.7423V24.3672H90.8976Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.67 33.5093H96.7239L95.3193 35.806H92.1389L99.3058 24.3594H102.359L109.164 35.806H105.983L104.67 33.5093ZM103.328 31.1849L100.81 26.7944L98.1279 31.1849H103.328Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.714 33.4802V35.8138H110.568V24.3672H113.53V33.4802H123.714Z",
    fill: "#0032A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27176_57487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123.429,
    height: 36,
    fill: "white",
    transform: "translate(0.285645)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalLogo);
export default __webpack_public_path__ + "static/media/signal-logo.e9ae103d0a415cd82d8267522665ac42.svg";
export { ForwardRef as ReactComponent };